import { render, staticRenderFns } from "./shipments-wigs-list.vue?vue&type=template&id=46042cbe&scoped=true"
import script from "./shipments-wigs-list.vue?vue&type=script&lang=js"
export * from "./shipments-wigs-list.vue?vue&type=script&lang=js"
import style0 from "./shipments-wigs-list.vue?vue&type=style&index=0&id=46042cbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46042cbe",
  null
  
)

export default component.exports